import { observer } from 'mobx-react-lite'
import { type SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { Summary } from '@/features/jobs/drafting/components/JobCreation/Summary'

export interface SummaryContainerProps {
  vm: SubmissionViewModel
}

export const SummaryContainer = observer(function SummaryContainer({
  vm,
}: SummaryContainerProps) {
  return (
    <Summary
      legendInfo={vm.legendInfo}
      summaryItems={vm.summaryItems}
      isLoading={vm.isLoading}
    />
  )
})
